import React, { Component } from "react";
import { data } from "./HanDb";
import QnaText from "./function/QnaText";
// import { Pagination } from "antd";
import { Pagination } from "../../Common/Pagination/Pagination";
import "./style/Hboard.scss";
import { NavLink } from "react-router-dom";
import axios from "axios";
import { findByLabelText } from "@testing-library/dom";
import moment from "moment";
import { Table } from "antd";
import { formatDate } from "../../utils/func";
import ModalData from "./ModalData";
import NoticeService from "../../Modules/API/Notice.service";

const columns = [
  {
    title: "번호",
    dataIndex: "index",
    key: 1,
    width: "10%",
  },
  {
    title: "지역",
    dataIndex: "locate",
    key: 2,
    width: "10%",
  },
  {
    title: "종류",
    dataIndex: "type",
    key: 3,
    width: "15%",
  },
  {
    title: "제목",
    dataIndex: "title",
    key: 4,
    width: "20%",
  },
  {
    title: "최초 작성일",
    key: 5,
    dataIndex: "dateCreated",
    width: "15%",
  },
  {
    title: "마지막 수정일시",
    key: 6,
    dataIndex: "lastModificationDate",
    width: "20%",
  },
  {
    title: "진전",
    key: 7,
    dataIndex: "progress",
    width: "15%",
  },
];
class HboardQnaList extends Component {
  state = {
    currentPage: 0,
    cardsPerPage: 10,
    currentPageM: 0,
    cardsPerPageM: 6,
    list: [],

    // cardsperpage -> 보여주고 싶은 박스 개수
  };
  onPageNumberClicked = (newPage) => (event) => {
    this.handlePageNumberClicked(newPage);
  };
  onPreviousPageClicked = (newPage) => (event) => {
    this.handlePreviousPageClicked(newPage);
  };
  onNextPageClicked = (newPage) => (event) => {
    this.handleNextPageClicked(newPage);
  };
  handlePageNumberClicked = (newPage) => {
    // console.log("onPageNumberClicked", newPage);
    this.setState({ currentPage: newPage });
  };
  handlePreviousPageClicked = (newPage) => {
    // console.log("onPreviousPageClicked", newPage);
    this.setState({ currentPage: newPage });
  };
  handleNextPageClicked = (newPage) => {
    //console.log("onNextPageClicked", newPage);
    this.setState({ currentPage: newPage });
  };
  filterData = () => {
    let getData = [...this.state.list];
    let startIndex = this.state.currentPage * this.state.cardsPerPage;
    let endIndex = (this.state.currentPage + 1) * this.state.cardsPerPage;
    return getData.slice(startIndex, endIndex);
  };

  componentDidMount = () => {
    this.getAllList();
    this.getDataInfo();
  };
  getAllList = async () => {
    const rID = "hanbit_qna";
    await axios
      .get(`http://61.73.79.136:9229/api/resources?rID=${rID}`)

      .then((response) => {
        if (
          response &&
          response.data &&
          response.data.data &&
          response.data.data.rows
        ) {
          response.data.data.rows = response.data.data.rows.map((item) => {
            const date = new Date(item.simple_resources.createdAt);
            item.simple_resources.createdAt = `${date.getFullYear()}-${
              date.getMonth() + 1
            }-${date.getDate()}`;
            return item;
          });

          this.setState({
            ...this.state,
            list: response.data.data.rows,
          });
        } else {
          console.error("error");
        }
      })
      .catch((e) => console.log(e));
  };

  getDataInfo = async () => {
    const content_type = "hanbitQna";
    await NoticeService.getHanbitNotices(content_type).then((res) => {
      const mappedData = res.data.items.map((item, index) => {
        let newRow = {};
        newRow.index = index + 1;
        newRow.type = item.fields.type;
        newRow.title = item.fields.title;
        newRow.dateCreated = formatDate(item.fields.dateCreated);
        newRow.lastModificationDate = formatDate(item.fields.dateCreated); //check api data
        newRow.detail = item.fields?.detail || "";
        newRow.key = index;
        return newRow;
      });
      this.setState({
        ...this.state,
        dataTable: mappedData,
        cardsPerPage: res.data.limit,
      });
    });
  };

  // renderList = () => {
  //   const list = this.state.list;
  //   let startIndex = this.state.currentPage * this.state.cardsPerPage;
  //   let endIndex = (this.state.cardsPerPage + 1) * this.state.cardsPerPage;

  //   return list.slice(startIndex, endIndex);
  // };

  render() {
    const { dataTable, currentPage, cardsPerPage, total } = this.state;

    const dummyData = dataTable?.map((item) => ({
      ...item,
      locate: "서울",
      progress: "진행중",
    }));

    return (
      <div className="Hboard_Contaier">
        <div
          style={{
            marginBottom: "30px",
            display: "flex",
            justifyContent: "flex-end",
          }}
        >
          <NavLink
            className="Mobile_link"
            to={`${this.props.match.path}/WriteBoard`}
          >
            <button
              type="button"
              style={{
                backgroundColor: "white",
                border: "1px solid black",
                // borderRadius: "4px",
                padding: "6px 10px",
              }}
            >
              게시글 작성
            </button>
          </NavLink>
        </div>
        <Table
          rowKey={(row) => row.index}
          className="custom-table"
          columns={columns}
          dataSource={dummyData}
          pagination={false}
          expandable={{
            expandRowByClick: true,
            expandedRowRender: (record) => <ModalData item={record} />,
            expandIcon: () => <div />,
          }}
        />

        <div>
          {this.filterData().map((item, index) => {
            return (
              <NavLink
                className="Link"
                data={item}
                to={`/HanbitQna/InBoard?name=${item.name}`}
              >
                <QnaText
                  key={index}
                  number={
                    this.state.currentPage === 0
                      ? this.state.list.length - index
                      : this.state.list.length -
                        index -
                        this.state.currentPage * 10
                  }
                  createdDate={moment(item.simple_resources.createdAt).format(
                    "YYYY-M-D"
                  )}
                  date={moment(item.lastUpdateDate).format("YYYY-M-D HH:MM:SS")}
                  title={item.resources[0].data[0]}
                  people={item.simple_resources.uploaderName}
                  reply={item.simple_resources.replyAt}
                />
              </NavLink>
            );
          })}
        </div>
        {total > cardsPerPage && (
          <Pagination
            currentPage={currentPage}
            cardsPerPage={cardsPerPage}
            itemCount={total}
            onPageNumberClicked={this.onPageNumberClicked}
            onPreviousPageClicked={this.onPreviousPageClicked}
            onNextPageClicked={this.onNextPageClicked}
          />
        )}
      </div>
    );
  }
}

export default HboardQnaList;
